import http from "../httpService";
import {getBaseUrl} from "../../config";

export const getReferralPaymentReport = (paginate) => {

  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/referral_payment_report`,
    );
  }
  return http.get(
    `${getBaseUrl()}/referral_payment_report?${paginate}`,
  );
};